/**
 * 同步第三方课件信息
 * @Author twu
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool} from '@/tool'
import {modelUtils} from "@/utils";

let {WizForm, WizSpin, WizButton} = component_tool

let {
  WizContainer,
} = framework_tool;


class CoursewareSync extends WizContainer {
  componentName = 'coursewareSync';

  constructor(props) {
    super(props);
    this.state = {
      formKey: (new Date().getTime()),
    };
    this.clearWizCallBack = [];
  }

  propsAndStateOnChange = {
    syncCourseware: this._updateOver.bind(this),
  };

  _componentDidMount() {
  }

  /**
   * 保存后返回提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _updateOver(nextProps, nextState) {
    if (nextProps.syncCourseware.code === 1) {
      wizNotice.success("操作成功");
      this.initMsgAuth = this.msgAuth;
      nextState.formKey = (new Date().getTime()),
        this.refreshList();
    } else {
      wizNotice.error(nextProps.syncCourseware.msg);
    }
    return true
  }

  /**
   * 更新原列表
   */
  refreshList() {
    let {changeModal} = this.props;
    changeModal && changeModal(false, true)
  }


  /**
   * 同步
   */
  _update = () => {
    this.formData.validateFields((err, values) => {
      let value = Object.assign([], values)
      if (!err) {
        this.doAction({
          path: "coursewareManagement/add",
          payload: {
            key: 'syncCourseware',
            apiParams: {
              ...value
            }
          }
        });
      }
      return
    });
  };

  _reset = () => {
    this.formData.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    });
    this.setState({
      formKey: (new Date().getTime()),
    })
    this.refreshList();
  }

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }

  _setSyncCoursewareColumns = () => {
    return [
      {
        title: "平台",
        name: "channel",
        dataIndex: "channel",
        formItem: {
          type: 'select',
          rules: [{
            required: true,
            message: '请选择平台',
          }],
        },
        dict: [
          {code: 1, codeName: "scorm平台"},
        ],
      },
      {
        title: "课件编码",
        name: "code",
        dataIndex: "code",
        formItem: {
          rules: [{
            required: true,
            message: '请输入第三方课件编码',
          }],
          placeholder: "请输入第三方课件编码。"
        }
      },
    ]
  }

  _render() {
    let {coursewareManagementLoading} = this.props;

    let columns = this._setSyncCoursewareColumns();
    return (
      <WizSpin tip={''} spinning={coursewareManagementLoading}>
        <WizForm
          {...this.props}
          columns={columns}
          ref={r => {
            this.formData = r
          }}
          key={this.state.formKey}
        />
        <div class="ant-modal-footer">
          <WizButton onClick={this._reset.bind(this)}>取消</WizButton>
          <WizButton type="primary" style={{marginLeft: 20}} onClick={this._update.bind(this)}>确认</WizButton>
        </div>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {coursewareManagement} = state;
  const syncCourseware = modelUtils.getModelEntity(coursewareManagement, "syncCourseware");
  const load = modelUtils.getLoadingState(state, ['coursewareManagement']);
  return {
    syncCourseware: syncCourseware,
    ...load
  }
};
const options = {withRef: true};
export default connect(mapStateToProps, null, null, options)(CoursewareSync);
